<template>
    <div class="study-material">
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title">{{ $t('trainingMaterial') }}</span></template>
            <template v-slot:right>
                <div style="display: flex; flex-direction: row; width: 100%">
<!--                    <span style="font-size: 26px; font-weight: bold">{{ $t('trainingMaterial') }}</span>-->
                    <v-btn class="btn-add-material" color="blue" style="color: #ffffff" @click="addStudyMaterial = true">{{ $t('add') }}</v-btn>
                </div>
            </template>
        </SuperAdminSchoolHead>

        <div style="padding: 10px" v-if="materials.length">
            <!--        <table class="table">-->
            <v-pagination v-model="currentPage"  :length="totalPages" v-if="totalPages > 1" :total-visible="10"></v-pagination>
            <v-simple-table style="margin: 12px auto; width: max-content; min-width: 70% ">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th style="font-size: 16px; font-weight: bold">{{ $t('class') }}</th>
                        <th style="font-size: 16px; font-weight: bold">{{ $t('course') }}</th>
                        <th style="font-size: 16px; font-weight: bold">Описание</th>
                        <th style="font-size: 16px; font-weight: bold">Автор</th>
                        <th style="font-size: 16px; font-weight: bold"></th>
                        <th style="font-size: 16px; font-weight: bold"></th>
                        <th style="font-size: 16px; font-weight: bold"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="material in materials" :key="material.id">
                        <td>{{material.classLevel}}</td>
                        <td>{{material.courseTitle}}</td>
                        <td style="max-width: 500px;">{{material.description}}</td>
                        <td style="max-width: 500px;">{{material.author}}</td>
                        <td style="max-width: 500px;"><a :href="material.url">Ссылка на книгу</a></td>
                        <td style="max-width: 500px;">
                            <v-btn :disabled="!material.attachmentUrl" variant="outlined" size="large" icon color="green" @click="downloadFile(material.attachmentUrl)">
                                <v-icon>mdi mdi-download</v-icon>
                            </v-btn></td>
                        <td style="max-width: 500px;">
                            <v-btn variant="outlined" size="large" icon color="red" @click="deleteStudyMaterial(material.id)">
                                <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <!--        </table>-->
        </div>
        <v-dialog v-model="addStudyMaterial" style="width: max-content">
            <div class="modal-container">
                <h4>{{$t('addMaterial')}}</h4>
                <v-select :label="$t('class')" :items="classLevels" item-text="num" item-value="num"
                          v-model="materialObj.classLevel" outlined dense/>
                <v-select :label="$t('course')" :items="courseList" item-text="courseTitle" item-value="id"
                          v-model="materialObj.courseId" outlined dense/>
                <v-text-field :label="`Описание`" outlined dense v-model="materialObj.description"/>
                <v-text-field :label="`Автор`" outlined dense v-model="materialObj.author"/>
                <v-file-input outlined dense chips show-size accept=".pdf" :rules="fileRules"
                              :label="`Прикрепить файл`" v-model="materialObj.file"/>
                <v-text-field :label="`Ссылка на книгу`" outlined dense v-model="materialObj.url"/>
                <div class="btn-actions">
                    <v-btn color="red" @click="clearMaterialOnj">{{ $t('cancel') }}</v-btn>
                    <v-btn color="green" @click="submitCreate" :disabled="fileType">{{$t('download1')}}</v-btn>
                </div>
            </div>
        </v-dialog>
        <!--MATERIAL MODAL-->
<!--        <modal name="material-modal" height="auto">-->
<!--            <div class="modal-container">-->
<!--                <h4>{{$t('addMaterial')}}</h4>-->
<!--                <v-select :label="$t('class')" :items="classLevels" item-text="num" item-value="num"-->
<!--                          v-model="materialObj.classLevel" outlined dense/>-->
<!--                <v-select :label="$t('course')" :items="courseList" item-text="courseTitle" item-value="id"-->
<!--                          v-model="materialObj.courseId" outlined dense/>-->
<!--                <v-file-input outlined dense chips show-size accept="*" :label="$t('downloadFile')" v-model="materialObj.file"/>-->
<!--                <div class="btn-actions">-->
<!--                    <v-btn color="red" @click="toggleAddModal">{{ $t('cancel') }}</v-btn>-->
<!--                    <v-btn color="green" @click="submitCreate">{{$t('download1')}}</v-btn>-->
<!--                </div>-->
<!--            </div>-->
<!--        </modal>-->
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import StudyMaterialService from '@/_services/study-material.service'
import { CourseService } from '@/_services/course.service'
const courseService = new CourseService()

export default {
  components: {
    SuperAdminSchoolHead
  },
  data () {
    return {
      classLevels: [{ num: '0' }, { num: 1 }, { num: 2 }, { num: 3 }, { num: 4 }, { num: 5 }, { num: 6 }, { num: 7 },
        { num: 8 }, { num: 9 }, { num: 10 }, { num: 11 }],
      materials: [],
      courseList: [],
      currentPage: 1,
      totalPages: 0,
      addStudyMaterial: false,
      fileType: false,
      materialObj: {
        classLevel: null,
        courseId: null,
        author: '',
        description: '',
        schoolId: '',
        url: '',
        file: null
      },
      fileRules: [
        value => {
          if (value) {
            if (value.type !== 'application/pdf') {
              this.fileType = true
              return 'Только .pdf формат'
            }
            if (value.size > 10485760) {
              this.fileType = true
              return 'Размер файла не должен превышать 10MB'
            }
            return true
          }
          this.fileType = false
          return true
        }
      ]
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    }
  },
  created () {
    this.materialObj.schoolId = this.school.id
    this.getAllMaterials(0)
    this.getSchoolCourseList()
  },
  watch: {
    async currentPage (val) {
      if (val === 0) this.getAllMaterials(val)
      else this.getAllMaterials(val - 1)
    }
  },
  methods: {
    downloadFile (url) {
      window.location = `http://172.30.0.9:5005/api/v1/file/download?fileName=${url}`
    },
    deleteStudyMaterial (id) {
      StudyMaterialService.deleteMaterial(id).then(res => {
        this.getAllMaterials(0)
        this.currentPage = 1
      })
    },
    getAllMaterials (page) {
      StudyMaterialService.fetchList(this.school.id, page).then((res) => {
        this.materials = res.content
        this.totalPages = res.totalPages
      }).catch((err) => {
        this.$toast.error(err)
      })
    },

    getSchoolCourseList () {
      courseService.listBySchool(this.school.id).then(res => {
        if (res) {
          courseService.listBySchool(this.school.id, '', 0, res.totalElements).then(result => {
            this.courseList = result.content
          })
        }
      })
    },

    submitCreate () {
      const formData = new FormData()
      Object.entries(this.materialObj).map((item) => formData.append(item[0], item[1]))
      StudyMaterialService.create(formData).then(() => {
        this.$toast.success(this.$t('success'))
        this.clearMaterialOnj()
        this.getAllMaterials(0)
      }).catch((err) => {
        this.$toast.error(err)
      })
    },
    clearMaterialOnj () {
      this.addStudyMaterial = false
      this.materialObj.classLevel = null
      this.materialObj.courseId = null
      this.materialObj.author = ''
      this.materialObj.description = ''
      this.materialObj.url = ''
      this.materialObj.file = null
    }
  }
}
</script>

<style scoped>
.study-material{}
.btn-add-material{}
@media (max-width: 420px) {
    .btn-add-material{
        width: 100%!important;
    }
    .sas-title {
        font-size: 20px!important;
    }
    .sas-head{
        flex-wrap: wrap;
        margin: 0!important;
        align-items: center;
        justify-content: center!important;
    }
}

th, td{
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
}
td{
    padding: 10px 16px !important;
}
</style>
